<template>
  <div class="mb-2 text-sm text-gray-700">
    <slot></slot>
  </div>
</template>
